import type {
  MetricName,
  MetricTags,
  MetricTagsByName,
} from 'src/internal/metrics/types';
import type {ObservabilityConfig} from 'src/types';

export default function buildParams<T extends MetricName>(
  config: ObservabilityConfig,
  metricName: T,
  parameters?: MetricTagsByName,
): MetricTags<T> | undefined {
  const configParams = config.metrics?.parameters;
  const wildcardParams: MetricTagsByName = configParams?.['*'] || {};
  const metricSpecificParams: MetricTagsByName =
    configParams?.[metricName] || {};
  const result: MetricTagsByName = {
    ...wildcardParams,
    ...metricSpecificParams,
    ...parameters,
  };

  if (Object.keys(result).length === 0) {
    return undefined;
  }

  return result as MetricTags<T>;
}
